"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toaster = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Panel_1 = require("../Panel");
var mobx_react_1 = require("mobx-react");
var UiAction_1 = require("../../uiAction/UiAction");
var Toaster = (0, mobx_react_1.observer)(function (props) {
    var panelProps = {
        type: Panel_1.PanelTypes.BORDER_LEFT_PRIMARY,
        background: Panel_1.PanelBackgrounds.BG_WHITE,
        hasShadow: true,
        hasBorderRadius: true
    };
    if (props.panelProps) {
        panelProps = __assign(__assign({}, panelProps), props.panelProps);
    }
    return ((0, jsx_runtime_1.jsxs)(Panel_1.Panel, __assign({}, panelProps, { className: "toaster mb-3 mx-3 ".concat(props.animationsClassName || ""), onMouseEnter: props.onMouseEnter }, { children: [props.actions && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "toaster__actions" }, { children: [props.actionAlignedTitle && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "toaster__action-aligned-title" }, { children: props.actionAlignedTitle }))), props.actions.map(function (e, i) {
                        return (0, jsx_runtime_1.jsx)(UiAction_1.UiActionComponent, { action: e }, i);
                    })] }))), (0, jsx_runtime_1.jsx)("div", __assign({ className: "toaster__content" }, { children: props.children }))] })));
});
exports.Toaster = Toaster;
